import './style.css';

interface Props {
  message: string;
}

export default function ThError({ message }: Props) {
  return <div className="th-error">{message}</div>;
}
